const teams = [
  // Tier 1 — +475 to +850
  { id: "spain",       name: "Spain",        flag: "🇪🇸", cc: "es",     tier: 1,  apiId: 9,    group: "H" },
  { id: "france",      name: "France",       flag: "🇫🇷", cc: "fr",     tier: 1,  apiId: 2,    group: "I" },
  { id: "england",     name: "England",      flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿", cc: "gb-eng", tier: 1,  apiId: 10,   group: "L" },
  { id: "brazil",      name: "Brazil",       flag: "🇧🇷", cc: "br",     tier: 1,  apiId: 6,    group: "C" },

  // Tier 2 — +900 to +2200
  { id: "argentina",   name: "Argentina",    flag: "🇦🇷", cc: "ar",     tier: 2,  apiId: 26,   group: "J" },
  { id: "portugal",    name: "Portugal",     flag: "🇵🇹", cc: "pt",     tier: 2,  apiId: 27,   group: "K" },
  { id: "germany",     name: "Germany",      flag: "🇩🇪", cc: "de",     tier: 2,  apiId: 25,   group: "E" },
  { id: "netherlands", name: "Netherlands",  flag: "🇳🇱", cc: "nl",     tier: 2,  apiId: 1118, group: "F" },

  // Tier 3 — +3500 to +5000
  { id: "belgium",     name: "Belgium",      flag: "🇧🇪", cc: "be",     tier: 3,  apiId: 1,    group: "G" },
  { id: "norway",      name: "Norway",       flag: "🇳🇴", cc: "no",     tier: 3,  apiId: 1090, group: "I" },
  { id: "colombia",    name: "Colombia",     flag: "🇨🇴", cc: "co",     tier: 3,  apiId: 8,    group: "K" },
  { id: "morocco",     name: "Morocco",      flag: "🇲🇦", cc: "ma",     tier: 3,  apiId: 31,   group: "C" },

  // Tier 4 — +5000 to +6500
  { id: "uruguay",     name: "Uruguay",      flag: "🇺🇾", cc: "uy",     tier: 4,  apiId: 7,    group: "H" },
  { id: "usa",         name: "USA",          flag: "🇺🇸", cc: "us",     tier: 4,  apiId: 2384, group: "D" },
  { id: "switzerland", name: "Switzerland",  flag: "🇨🇭", cc: "ch",     tier: 4,  apiId: 15,   group: "B" },
  { id: "japan",       name: "Japan",        flag: "🇯🇵", cc: "jp",     tier: 4,  apiId: 12,   group: "F" },

  // Tier 5 — +8000 to +9000
  { id: "ecuador",     name: "Ecuador",      flag: "🇪🇨", cc: "ec",     tier: 5,  apiId: 2382, group: "E" },
  { id: "croatia",     name: "Croatia",      flag: "🇭🇷", cc: "hr",     tier: 5,  apiId: 3,    group: "L" },
  { id: "mexico",      name: "Mexico",       flag: "🇲🇽", cc: "mx",     tier: 5,  apiId: 16,   group: "A" },
  { id: "senegal",     name: "Senegal",      flag: "🇸🇳", cc: "sn",     tier: 5,  apiId: 13,   group: "I" },

  // Tier 6 — +10000 to +20000
  { id: "turkey",      name: "Turkey",       flag: "🇹🇷", cc: "tr",     tier: 6,  apiId: 777,  group: "D" },
  { id: "sweden",      name: "Sweden",       flag: "🇸🇪", cc: "se",     tier: 6,  apiId: 5,    group: "F" },
  { id: "austria",     name: "Austria",      flag: "🇦🇹", cc: "at",     tier: 6,  apiId: 775,  group: "J" },
  { id: "scotland",    name: "Scotland",     flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿", cc: "gb-sct", tier: 6,  apiId: 1108, group: "C" },

  // Tier 7 — +20000 to +30000
  { id: "canada",      name: "Canada",       flag: "🇨🇦", cc: "ca",     tier: 7,  apiId: 5529, group: "B" },
  { id: "czechia",     name: "Czechia",      flag: "🇨🇿", cc: "cz",     tier: 7,  apiId: 770,  group: "A" },
  { id: "ivorycoast",  name: "Ivory Coast",  flag: "🇨🇮", cc: "ci",     tier: 7,  apiId: 1501, group: "E" },
  { id: "ghana",       name: "Ghana",        flag: "🇬🇭", cc: "gh",     tier: 7,  apiId: 1504, group: "L" },
  { id: "egypt",       name: "Egypt",        flag: "🇪🇬", cc: "eg",     tier: 7,  apiId: 32,   group: "G" },
  { id: "paraguay",    name: "Paraguay",     flag: "🇵🇾", cc: "py",     tier: 7,  apiId: 2380, group: "D" },

  // Tier 8 — +35000 to +70000
  { id: "algeria",     name: "Algeria",      flag: "🇩🇿", cc: "dz",     tier: 8,  apiId: 1532, group: "J" },
  { id: "southkorea",  name: "South Korea",  flag: "🇰🇷", cc: "kr",     tier: 8,  apiId: 17,   group: "A" },
  { id: "tunisia",     name: "Tunisia",      flag: "🇹🇳", cc: "tn",     tier: 8,  apiId: 28,   group: "F" },
  { id: "bosnia",      name: "Bosnia & Herz.", flag: "🇧🇦", cc: "ba",   tier: 8,  apiId: 1113, group: "B" },
  { id: "australia",   name: "Australia",    flag: "🇦🇺", cc: "au",     tier: 8,  apiId: 20,   group: "D" },
  { id: "iran",        name: "Iran",         flag: "🇮🇷", cc: "ir",     tier: 8,  apiId: 22,   group: "G" },

  // Tier 9 — +100000
  { id: "drcongo",     name: "DR Congo",     flag: "🇨🇩", cc: "cd",     tier: 9,  apiId: 1508, group: "K" },
  { id: "southafrica", name: "South Africa", flag: "🇿🇦", cc: "za",     tier: 9,  apiId: 1531, group: "A" },
  { id: "capeverde",   name: "Cape Verde",   flag: "🇨🇻", cc: "cv",     tier: 9,  apiId: 1533, group: "H" },
  { id: "saudiarabia", name: "Saudi Arabia", flag: "🇸🇦", cc: "sa",     tier: 9,  apiId: 23,   group: "H" },
  { id: "panama",      name: "Panama",       flag: "🇵🇦", cc: "pa",     tier: 9,  apiId: 11,   group: "L" },
  { id: "uzbekistan",  name: "Uzbekistan",   flag: "🇺🇿", cc: "uz",     tier: 9,  apiId: 1568, group: "K" },

  // Tier 10 — +150000 to +250000
  { id: "qatar",       name: "Qatar",        flag: "🇶🇦", cc: "qa",     tier: 10, apiId: 1569, group: "B" },
  { id: "newzealand",  name: "New Zealand",  flag: "🇳🇿", cc: "nz",     tier: 10, apiId: 4673, group: "G" },
  { id: "iraq",        name: "Iraq",         flag: "🇮🇶", cc: "iq",     tier: 10, apiId: 1567, group: "I" },
  { id: "haiti",       name: "Haiti",        flag: "🇭🇹", cc: "ht",     tier: 10, apiId: 2386, group: "C" },
  { id: "curacao",     name: "Curaçao",      flag: "🇨🇼", cc: "cw",     tier: 10, apiId: 5530, group: "E" },
  { id: "jordan",      name: "Jordan",       flag: "🇯🇴", cc: "jo",     tier: 10, apiId: 1548, group: "J" },
];

export default teams;
